import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { carouselCrumb } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import { deleteCarousel, getProductGroupHome } from 'actions/EntityActions';
import WithRouter from 'custom/withRouter';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import DialogHeader from 'screens/components/basic/DialogHeader';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class carouselPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            productList: [],
            value: 'Active',
            status: 'Active',
            linkURL: '/ecommerce/carousel/add'

        }
    }

    componentWillMount() {
        this.getProductGroupHome();
    }

    confirmDeleteCarousel = (itemID) => {
        this.props.deleteCarousel({
            carouselId: itemID,
            branchId: this.props.branchId,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage
        });
        this.closeDialog();
    };

    componentWillReceiveProps(props) {
        if (props.productGroupList.hasOwnProperty('list') && props.productGroupList.list !== this.props.productGroupList.list) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    productList: props.productGroupList.list.map(item => {
                        return {
                            Name: item.name,
                            Description: item.description,
                            Status: (item.status == 1 ? <p className="statusIconGreen m-0">Active</p> : <p className="statusIconRed m-0">Inactive</p>),
                            EditIcons:
                                (
                                    <Button
                                        type="IconEditButton"
                                        onTouchTap={() => this.editProductGroupHome(item.id)}
                                    />
                                ),
                            DeleteIcons: (
                                <Button
                                    mini={true}
                                    type="IconRemoveButton"
                                    onTouchTap={() => this.openDialog(item.id)}
                                />
                            )
                        };
                    })
                };
            });
        }
    }

    openDialog = (itemId) => {
        this.setState({ dialog: true, itemId: itemId });
    };

    closeDialog = () => {
        this.setState({ dialog: false });
    };
    getProductGroupHome() {
        this.props.getProductGroupHome({
            branchId: this.props.branchId,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage
        });
    }

    editProductGroupHome(id) {
        this.props.navigate(`/ecommerce/carousel/edit/${id}`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getProductGroupHome
        );
    }

    /**
     * String {status} - can be Active or Inactive.
     */
    setStatus = (status) => {
        if (status && status === 'Active' || status === 'Inactive') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    status: status,
                    activePage: 1
                };
            }, this.getProductGroupHome);
        }

    }

    handleChange = (value) => {
        this.setState(pState => {
            return {
                ...pState,
                value: value
            };
        }, () => this.setStatus(value));
    };

    render() {
        let linkAdd = this.state.linkURL;

        return (
            <Grid headerContent={carouselCrumb}>
                <PageHeaderWithButton title={LOOKUP.ecommerce.carousel.carouselList.title}>
                    <Button
                        type="AddButton"
                        mini
                        className="bg-light-green"
                        label="ADD NEW CAROUSEL"
                        onTouchTap={() => this.props.navigate(linkAdd)}
                    />
                </PageHeaderWithButton>
                <CardSimple>
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont"
                        tableBodyClassName="productgroup-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        columns={LOOKUP.ecommerce.listTableColumns}
                        rows={this.state.productList}
                        stripedRows={true}
                    />
                    <Pagination
                        length={this.props.productGroupList.total || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={this.changePage} />
                </CardSimple>
                <DialogInput
                    title={
                        <div className="modal-title noPadding mb-2">
                            <DialogHeader
                                text="CONFIRM DELETE"
                                classicClass="posDialogClassic"
                            />
                        </div>
                    }
                    modal={true}
                    open={this.state.dialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: "950" }}
                    actions={[
                        <Button
                            key={1}
                            name="CancelButton"
                            label="Cancel"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.closeDialog()}
                        />,
                        <Button
                            key={2}
                            name="ConfirmDelete"
                            label="Delete"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.confirmDeleteCarousel(this.state.itemId)}
                        />
                    ]}
                    contentStyle={{ width: "65%" }}
                >
                    <div>
                        <div className="row">
                            <div className="col-lg-12">
                                <h4 className="purpleText">
                                    Are you sure you wish to delete this Carousel?
                                </h4>
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}
function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        productGroupList: state.entity.productGroupList,
        isMedical: state.common.applicationSettings.isMedical
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getProductGroupHome: model => dispatch(getProductGroupHome(model)),
        showError: (message) => dispatch(showError(message)),
        deleteCarousel: model => dispatch(deleteCarousel(model))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(carouselPage));
